<template>
  <div id="app">
    <search-bar ref="searchBarComponent">
      <div slot="search-tool">
      </div>
      <div slot="search-cont">

        <div class="item">
          <div class="item-label">接送时间</div>
          <el-date-picker v-model="info.begintimes" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" @change="interviewTimeChange"></el-date-picker>
        </div>

        <div class="item" >
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
              <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                <el-option label="求职者" value="1"></el-option>
                <el-option label="司机" value="2"></el-option>
                <el-option label="上车地点" value="3"></el-option>
                <el-option label="面试工厂" value="4"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
            </el-input>
          </div>
        </div>
        <!--  操作按钮 start -->
          <div class="item">
            <el-button class="item-btn" type="primary" @click="queryInfo">查询</el-button>

          </div>
        <!--  操作按钮 end -->

      </div>
    </search-bar>
    <div class="operation-tool">
      <div class="sum-data">
        <div class="sum-data-item"><span>应收：{{sum.totalfee}} 元</span> </div>
        <div class="sum-data-item"><span>实收：{{sum.totalrealityfee}} 元</span>  </div>
      </div>
    </div>
    <div class="l-panel">
      <div class="panel-body">
        <el-table class="l-table" :data="tableData" style="width: 100%">
          <el-table-column prop="resume_name" label="求职者" align="left"></el-table-column>
          <el-table-column prop="company_name" label="面试工厂" align="left"></el-table-column>
          <el-table-column prop="interview_time" label="面试时间" align="left"></el-table-column>
          <el-table-column prop="shop_name" label="上车地点" align="left"></el-table-column>
          <el-table-column prop="jobs_name" label="面试职位" align="left"></el-table-column>
          <el-table-column prop="fee" label="应收车费" align="right"></el-table-column>
          <el-table-column prop="realityfee" label="实收车费" align="right"></el-table-column>
          <el-table-column prop="driver_cn" label="司机" align="left"></el-table-column>
          <el-table-column prop="draddtime" label="司机操作时间" align="left"></el-table-column>
          <el-table-column prop="shop_remark" label="上车备注" align="left"></el-table-column>
          <el-table-column prop="refund_carfee_status" label="是否退费" align="left">
          	<template slot-scope='{row}'>
	         
	          <span v-if="row.refund_carfee_status == 1">已退费</span>
	          <span v-else="">否</span>
	
	          </template>
          </el-table-column>
        </el-table>

        <div class="c-table-pager">
          <el-pagination @current-change="paginationChange" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          key:'',
          begintimes:[],
          begintime:'',
          endtime:'',
          key_type:''

        },
        total: 1,
        tableData:[],
        sum:{totalfee:0,totalrealityfee:0},

      }
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    mounted() {
      this.queryInfo()
    },
    methods: {
      paginationChange(val) {
        this.info.page = val
        this.queryInfo()
      },

      interviewTimeChange(val) {
        this.info.begintime = val[0]
        this.info.endtime = val[1]
        this.info.page = 1
        this.queryInfo()
      },

      searchResume() {
        if(!this.info.key_type){return Message.warning('请选择搜索类型')}
        this.info.page = 1
        this.queryInfo()
      },

      queryInfo() {
        this.gets('oasystem/carlist', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total;
          this.sum.totalfee = res.data.data.totalfee;
          this.sum.totalrealityfee = res.data.data.totalrealityfee;
        })
      }
    }
  }
</script>

<style scoped>
  .table {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
  }

 .pagination {
    margin: 20px auto;
    width: 100%;
    text-align: center;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/oacarlist.vue